import { AnalyticsUserEvent } from '@fruitful/types';
import { usePathname } from 'expo-router';
import {
    BackButton,
    BackButtonIconType,
    BodyLargeRegular,
    BodySmallRegular,
    isNonMobileWeb,
    isWeb,
    SafeAreaView,
    useThemeColors,
    XStack,
    YStack,
} from 'smoothie';

import { MessagingBadgeButton } from '../../common/components/MessagingBadgeButton';
import { track } from '../../logger/Logger';

const HEADER_SIDE_WIDTH = 50;
const HEADER_SIDE_HEIGHT = 50;

export const RoadmapScreenHeader = ({
    title,
    subtitle,
    hasBackButton = true,
    hasMessagingButton = false,
    onBack,
    contentAboveTitle,
    rightContent,
}: {
    title?: string;
    subtitle?: string;
    hasBackButton?: boolean;
    hasMessagingButton?: boolean;
    onBack?: () => void;
    contentAboveTitle?: React.ReactNode;
    rightContent?: React.ReactNode;
}) => {
    const pathname = usePathname();
    const { getColor } = useThemeColors();

    return (
        <SafeAreaView
            noBottomPadding={true}
            edges={['top', 'left', 'right']}
            style={{
                width: '100%',
                paddingTop: isWeb ? 20 : 8,
                paddingHorizontal: isNonMobileWeb ? 16 : 8,
                backgroundColor: getColor('$white'),
                zIndex: 1, // So content will scroll behind the header
            }}
        >
            {contentAboveTitle}
            <XStack
                width="100%"
                paddingTop={isNonMobileWeb ? 12 : 0}
                paddingBottom={0}
                maxWidth={700}
                alignSelf="center"
                alignItems="center"
                justifyContent="space-between"
            >
                <YStack
                    width={HEADER_SIDE_WIDTH}
                    height={HEADER_SIDE_HEIGHT}
                    justifyContent="center"
                    paddingLeft={isNonMobileWeb ? 0 : 8}
                    flexGrow={1}
                >
                    {hasBackButton && (
                        <BackButton
                            fallbackRoute="/roadmap/go/start"
                            iconType={BackButtonIconType.ARROW_LEFT}
                            customBackFn={onBack}
                            onBeforeGoingBack={() => {
                                track(AnalyticsUserEvent.BACK, {
                                    pathname,
                                    workflow: 'MoneyMap',
                                });
                            }}
                        />
                    )}
                </YStack>
                <YStack alignItems="center" flexGrow={0}>
                    <BodyLargeRegular>{title}</BodyLargeRegular>
                    {subtitle != null && subtitle.length > 0 && (
                        <BodySmallRegular color="$gray1000">
                            {subtitle}
                        </BodySmallRegular>
                    )}
                </YStack>
                <XStack
                    flexGrow={1}
                    width={HEADER_SIDE_WIDTH}
                    height={HEADER_SIDE_HEIGHT}
                    alignItems="center"
                    justifyContent="flex-end"
                    paddingRight={isNonMobileWeb ? 0 : 8}
                >
                    {rightContent ??
                        (hasMessagingButton && <MessagingBadgeButton />)}
                </XStack>
            </XStack>
        </SafeAreaView>
    );
};
